export const EditableDataFromatter = (data) => {
  const FormattedEditableData = data?.map((items) => items.ItemValue);
  return FormattedEditableData;
};
